import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "label"]
  static values = { feedback: { type: String, default: "Copied!" } }

  async copy() {
    const text = this.sourceTarget.textContent.trim()

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    this.showFeedback()
  }

  showFeedback() {
    const label = this.labelTarget
    const originalHTML = label.innerHTML

    label.textContent = this.feedbackValue
    label.classList.add("is-copied")

    setTimeout(() => {
      label.innerHTML = originalHTML
      label.classList.remove("is-copied")
    }, 2000)
  }
}
